(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseBookingPackages',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var i        = 0;
		var packages = $('.packages').data('packages');
		var checked  = $('.packages').data('checked');

		/*
		$('form.packages .cell').click(function cellClick() {
			var $self = $(this);
			var index = $self.prop('id');

			cruiseBookingSelectCell(index);
		});
		*/

		$('form.packages :checkbox').click(function checkboxClick() {
			var $self = $(this);
			var index = $self.prop('id').split(/-/)[1] + '-' + $self.prop('id').split(/-/)[2];

			cruiseBookingCheckPackage(index);
		});

		for (i = 0; i < checked.length; i++) {
			$('#cell-' + checked[i]).prop('checked', true);

			cruiseBookingCheckPackage(checked[i]);
		}

		function cruiseBookingCheckPackage(index, skipAvailCheck) {
			var i;
			var indexChunks    = index.split(/-/);
			var packageIndex   = indexChunks[0];
			var passengerIndex = indexChunks[1];
			var checkedPackagePassengers;
			var checkedPassengerPackages;

			if (skipAvailCheck === undefined && !$('#cell-' + index).prop('checked')) {
				if ($('#rbcl-' + packageIndex).val() !== '1') {
					$('#cell-' + index).prop('checked', true);

					Adzuki.CustomConfirm({
						title  : 'Package no longer available',
						content: 'This package is no longer being offered by the cruise line.  If you remove it, you may<br />not be able to re-add to the booking at a later time.  Are you sure you want to remove it?',
						confirm: function confirm() {
							$('#cell-' + index).prop('checked', false);
							cruiseBookingCheckPackage(index, true);
							return true;
						}
					});

					return;
				}
			}

			if ('packageRates' in packages[packageIndex]) {
				checkedPackagePassengers = 0;

				for (i = 0; $('#cell-' + packageIndex + '-' + i).length; i++) {
					if ($('#cell-' + packageIndex + '-' + i).prop('checked')) {
						checkedPackagePassengers++;
					}
				}

				if (checkedPackagePassengers === 0) {
					checkedPackagePassengers++;
				} else {
					while (!(checkedPackagePassengers in packages[packageIndex]['packageRates']) && checkedPackagePassengers >= 1) {
						checkedPackagePassengers--;
					}
				}

				$('#pp-' + packageIndex).html('$' + packages[packageIndex]['packageRates'][checkedPackagePassengers].toLocaleString("en-US", {
					style                : "currency",
					currency             : "USD",
					minimumFractionDigits: 2,
				}));
			}

			if ($('#cell-' + index).prop('checked')) {
				for (i = 0; $('#cell-' + i + '-' + passengerIndex).length; i++) {
					if (i !== parseInt(packageIndex)) {
						if (packages[i]['prePostCode'] === 'B') {
							$('#cell-' + i + '-' + passengerIndex).prop('checked', false);
							$('#cell-' + i + '-' + passengerIndex).prop('disabled', true);
						}

						if (packages[packageIndex]['prePostCode'] === 'B' || packages[packageIndex]['prePostCode'] === 'R') {
							if (packages[i]['prePostCode'] === 'R') {
								$('#cell-' + i + '-' + passengerIndex).prop('checked', false);
								$('#cell-' + i + '-' + passengerIndex).prop('disabled', true);
							} else if (packages[packageIndex]['groupCode'] === 'GT' && $('#cell-' + index).data('foundPrePost')) {
								if (packages[i]['prePostCode'] === 'O' && packages[i]['prePostCode'] === 'GT') {
									$('#cell-' + i + '-' + passengerIndex).prop('checked', false);
									$('#cell-' + i + '-' + passengerIndex).prop('disabled', true);
								}
							}
						}

						if (packages[packageIndex]['prePostCode'] === 'B' || packages[packageIndex]['prePostCode'] === 'O') {
							if (packages[i]['prePostCode'] === 'O') {
								$('#cell-' + i + '-' + passengerIndex).prop('checked', false);
								$('#cell-' + i + '-' + passengerIndex).prop('disabled', true);
							} else if (packages[packageIndex]['groupCode'] === 'GT' && $('#cell-' + index).data('foundPrePost')) {
								if (packages[i]['prePostCode'] === 'R' && packages[i]['prePostCode'] === 'GT') {
									$('#cell-' + i + '-' + passengerIndex).prop('checked', false);
									$('#cell-' + i + '-' + passengerIndex).prop('disabled', true);
								}
							}
						}
					}
				}
			} else {
				checkedPassengerPackages = 0;

				for (i = 0; $('#cell-' + i + '-' + passengerIndex).length; i++) {
					if ($('package' + i + '-' + passengerIndex).prop('checked') === true) {
						checkedPassengerPackages++;
					}
				}

				for (i = 0; $('#cell-' + i + '-' + passengerIndex).length; i++) {
					if (i !== parseInt(packageIndex)) {
						if (checkedPassengerPackages === 0) {
							if (packages[i]['prePostCode'] === 'B' && packages[i]['returnedByCruiseLine']) {
								$('#cell-' + i + '-' + passengerIndex).prop('disabled', false);
							}
						}

						if (packages[packageIndex]['prePostCode'] === 'B' || packages[packageIndex]['prePostCode'] === 'R') {
							if (packages[i]['prePostCode'] === 'R' && packages[i]['returnedByCruiseLine']) {
								$('#cell-' + i + '-' + passengerIndex).prop('disabled', false);
							} else if (packages[packageIndex]['groupCode'] === 'GT' && $('#cell-' + index).data('foundPrePost')) {
								if (packages[i]['prePostCode'] === 'O' && packages[i]['prePostCode'] === 'GT' && packages[i]['returnedByCruiseLine']) {
									$('#cell-' + i + '-' + passengerIndex).prop('disabled', false);
								}
							}
						}

						if (packages[packageIndex]['prePostCode'] === 'B' || packages[packageIndex]['prePostCode'] === 'O') {
							if (packages[i]['prePostCode'] === 'O' && packages[i]['returnedByCruiseLine']) {
								$('#cell-' + i + '-' + passengerIndex).prop('disabled', false);
							} else if (packages[packageIndex]['groupCode'] === 'GT' && $('#cell-' + index).data('foundPrePost')) {
								if (packages[i]['prePostCode'] === 'R' && packages[i]['prePostCode'] === 'GT' && packages[i]['returnedByCruiseLine']) {
									$('#cell-' + i + '-' + passengerIndex).prop('disabled', false);
								}
							}
						}
					}
				}
			}

			return;
		}

		/*
		function cruiseBookingSelectCell(index) {
			if ($('#cell-' + index).prop('disabled')) { return; }

			if ($('#cell-' + index).prop('checked') === false) {
				$('#cell-' + index).prop('checked', true);
			} else {
				$('#cell-' + index).prop('checked', false);
			}

			cruiseBookingCheckPackage(index);

			return;
		}
		*/
	};
}(jQuery, window.Adzuki || {}));
